import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const points = ['Terminas el mes sin saber cuánto dinero va a entrar', 'Cobras a ojo porque no sabes cuál es tu tarifa real', 'Tienes clientes que te retrasan pagos o directamente no pagan', 'No sabes cómo conseguir clientes de forma predecible', 'Cada proyecto acaba siendo más trabajo del que presupuestaste', 'Trabajas muchas horas pero el dinero no refleja el esfuerzo', 'Tu negocio depende de que aparezca alguien, no de un sistema'];
  return <Section data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <h2 className="md:text-5xl font-bold text-center mb-8 text-[40px]" data-id="element-134">
          ¿Cuántos meses más vas a trabajar sin saber si{' '}
          <span className="text-brand-accent" data-id="element-135">llegarás a fin de mes?</span>
        </h2>

        <p className="text-neutral-300 text-center mb-6 text-[16px]" data-id="element-136">
          Amás lo que hacés, pero terminás el mes sin saber cuánto vas a cobrar,
          persiguiendo clientes que no pagan, cobrando lo que te piden porque no
          sabes cómo decir que no.
        </p>

        <div className="text-center mb-12" data-id="element-137">
          <span className="inline-block bg-brand-accent/10 text-brand-accent font-bold px-6 py-3 rounded-lg text-xl border border-brand-accent/20" data-id="element-138">
            No es mala suerte. Es falta de un sistema.
          </span>
        </div>

        <div className="bg-brand-card border border-neutral-800 rounded-2xl p-8 md:p-10 mb-12" data-id="element-139">
          <ul className="space-y-5" data-id="element-140">
            {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-141">
                <span className="text-red-500 text-xl mt-0.5 shrink-0" data-id="element-142">❌</span>
                <span className="text-lg text-neutral-300" data-id="element-143">{point}</span>
              </li>)}
          </ul>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-144">
          ¿Y si este fuera el último mes que pasás así?
        </h3>
      </div>
    </Section>;
}